import moment from "moment";

class CoreDate {
  constructor() {
    moment.locale("ko");
  }

  format = new Format();

  instance(params) {
    return moment(params);
  }

  duration(param) {
    return moment.duration(param);
  }
}

class Format {
  elapsedTime(preTime) {
    const curTime = moment();
    let diffTime = curTime.diff(preTime, "minute");
    let elapsedTime = diffTime + "분전";
    //console.log(diffTime);
    if (diffTime > 525600) {
      diffTime = curTime.diff(preTime, "year");
      if (diffTime <= 0) diffTime = 1;
      elapsedTime = diffTime + "년전";
    } else if (diffTime > 43200) {
      diffTime = curTime.diff(preTime, "month");
      if (diffTime <= 0) diffTime = 1;
      elapsedTime = diffTime + "달전";
    } else if (diffTime > 1440) {
      diffTime = curTime.diff(preTime, "days");
      if (diffTime <= 0) diffTime = 1;
      elapsedTime = diffTime + "일전";
    } else if (diffTime > 60) {
      diffTime = curTime.diff(preTime, "hour");
      if (diffTime <= 0) diffTime = 1;
      elapsedTime = diffTime + "시간전";
    }
    return elapsedTime;
  }

  comment(strDate) {
    const curDate = moment();
    const date = moment(strDate);
    if (curDate.year() == date.year()) {
      // 년도 동일 경우 월. 일. 오전/오후 시:분
      if (curDate.month() == date.month() && curDate.day() == date.day()) {
        return date.format("a hh:mm");
      } else {
        return date.format("MM. DD. a hh:mm");
      }
    } else {
      return date.format("YYYY. MM. DD. a hh:mm");
    }
  }
}

export default new CoreDate();
